import { buildTrainingsDeskPath } from "@tennis-matches/core";

import {
  isParentBookingAwaitingTrainerReview,
  isParentBookingPendingTrainer,
} from "./parent-portal-booking-overlap.js";
import { normalizePlannedIds } from "./session-rsvp.js";
import { isCancelledSession } from "./session-status.js";

export const MOBILE_PLANNING_WEB_EDITOR_QUERY_KEY = "webEditor";
export const MOBILE_PLANNING_PARENT_BOOKING_QUERY_KEY = "parentBooking";

/**
 * @param {string} webPath
 * @returns {boolean}
 */
export function isMobilePlanningWebOnlyPath(webPath) {
  const raw = String(webPath || "").trim();
  const qIdx = raw.indexOf("?");
  if (qIdx < 0) return false;
  const query = new URLSearchParams(raw.slice(qIdx + 1));
  if (
    String(query.get(MOBILE_PLANNING_WEB_EDITOR_QUERY_KEY) || "").trim() === "1"
  ) {
    return true;
  }
  if (
    String(query.get(MOBILE_PLANNING_PARENT_BOOKING_QUERY_KEY) || "").trim() ===
    "1"
  ) {
    return true;
  }
  return false;
}

/**
 * @param {string} sessionId
 * @returns {string}
 */
export function buildMobileSessionPlanningWebPath(sessionId) {
  const sid = String(sessionId || "").trim();
  const base = buildTrainingsDeskPath("planung");
  if (!sid) return base;
  return `${base}?session=${encodeURIComponent(sid)}`;
}

/**
 * Voller Web-Planungseditor (Teilnehmer, Ferien, Assistenz) — nicht nativ abfangen.
 *
 * @param {string} [sessionId]
 * @returns {string}
 */
export function buildMobileSessionPlanningWebEditorPath(sessionId = "") {
  const base = buildTrainingsDeskPath("planung");
  const params = new URLSearchParams();
  params.set(MOBILE_PLANNING_WEB_EDITOR_QUERY_KEY, "1");
  const sid = String(sessionId || "").trim();
  if (sid) params.set("session", sid);
  return `${base}?${params.toString()}`;
}

/**
 * @param {string} sessionId
 * @returns {string}
 */
export function buildMobileSessionParentBookingWebPath(sessionId) {
  const base = buildTrainingsDeskPath("planung");
  const params = new URLSearchParams();
  params.set(MOBILE_PLANNING_WEB_EDITOR_QUERY_KEY, "1");
  params.set(MOBILE_PLANNING_PARENT_BOOKING_QUERY_KEY, "1");
  const sid = String(sessionId || "").trim();
  if (sid) params.set("session", sid);
  return `${base}?${params.toString()}`;
}

/**
 * @param {object|null|undefined} session
 * @returns {{
 *   plannedCount: number,
 *   isCancelled: boolean,
 *   isPendingParentBooking: boolean,
 *   isAwaitingParentBookingReview: boolean,
 *   isAttendanceConfirmed: boolean,
 * }}
 */
export function summarizeMobileSessionDetail(session) {
  const plannedCount = normalizePlannedIds(session).length;
  return {
    plannedCount,
    isCancelled: isCancelledSession(session),
    isPendingParentBooking: isParentBookingPendingTrainer(session),
    isAwaitingParentBookingReview:
      isParentBookingAwaitingTrainerReview(session),
    isAttendanceConfirmed: !!session?.attendance_confirmed,
  };
}
